<template>
  <div>
    <webview id="webview1" src="https://baidu.com"></webview>
    <button @click="startPrint1">打印网址</button>
    <webview id="webview2" src="http://192.168.1.105:8080/1.pdf"></webview>
    <button @click="startPrint2">打印PDF</button>
    <webview id="webview3" src="http://192.168.1.105:8080/111.docx"></webview>
    <button @click="startPrint3">打印WORD</button>
    <button @click="lodopPrint">打印页数</button>
    <button @click="getUsize">U盘盘符</button>
    <button @click="getFiilepath">electron读取</button>
  </div>
</template>
<script>
import lodop from "@/assets/js/doPrint.js"
export default {
  name: '',
  data() {
    return {
      //
      pf: ''
    };
  },
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    getFiilepath() {
      ipcRenderer.send('readdirDisk');
    },
    lodopPrint() {
      // lodop.testPrint('C:/Users/zshz/Desktop/fsdownload/打印控件功能演示.pdf', 4, pages => {
      //   console.log('打印页数', pages);
      // })
      lodop.zzPrint('http:/123.131.74.135:9000/yyzz//20240814/_1723628815863.jpeg')
    },
    getUsize() {
      this.$fun.getUsize(el => {
        console.log('U盘', el);
        this.pf = el
      })
    },
    //
    startPrint1() {
      let webview = document.getElementById('webview1')
      webview.print({
        silent: true, // 是否静默打印
        deviceName: '导出为WPS PDF' // 打印机名称
      })
    },
    startPrint2() {
      let webview = document.getElementById('webview2')
      webview.print({
        silent: true, // 是否静默打印
        deviceName: '导出为WPS PDF' // 打印机名称
      })
    },
    startPrint3() {
      let webview = document.getElementById('webview3')
      webview.print({
        silent: true, // 是否静默打印
        deviceName: '导出为WPS PDF' // 打印机名称
      })
    }
  }
};
</script>
<style scoped lang="scss">
// .webview {
//   position: fixed;
//   top: -99999999rem;
//   left: -99999999rem;
// }</style>